export enum ApplicationStatus {
  APPROVED = "APPROVED",
  CANCELED = "CANCELED",
  DRAFT = "DRAFT",
  MODERATION = "MODERATION",
  REJECTED = "REJECTED",
  SENT = "SENT",
}

export enum CategoryTypes {
  SOLO = "SOLO",
  DUO = "DUO",
  TRIO = "TRIO",
  OTHER = "OTHER",
}

export enum Gender {
  FEMALE = "FEMALE",
  MALE = "MALE",
}

/**
 * Tłumaczy wartość Gender na język polski
 */
export const getGenderTranslation = (gender: Gender): string => {
  switch (gender) {
    case Gender.FEMALE:
      return "Kobieta";
    case Gender.MALE:
      return "Mężczyzna";
    default:
      return "";
  }
};

/**
 * Tłumaczy wartość Gender na język polski (wersja dla formularzy)
 */
export const getGenderOptions = () => [
  { value: Gender.FEMALE, label: "Kobieta" },
  { value: Gender.MALE, label: "Mężczyzna" },
];

export enum PaymentsType {
  PER_PARTICIPANT = "ZA KAŻDY WYSTĘP ZAWODNIKA",
  PER_PARTICIPANT_IN_CATEGORY = "ZA KAŻDY WYSTĘP ZAWODNIKA W DANEJ KATEGORII",
  PER_PRESENTATION = "ZA KAŻDĄ PREZENTACJĘ W KATEGORII",
}

export enum StreetType {
  STREET = "Ulica",
  AVENUE = "Aleja",
  SQUARE = "Plac",
  ROAD = "Droga",
  ESTATE = "Osiedle",
}

export enum StartNumbersSystem {
  TOURNAMENT_WIDE = "PRZEZ TURNIEJ", // Narastająco od 1 do n pośród wszystkich prezentacji w ramach danego turnieju
  CATEGORY_BASED = "PRZEZ KATEGORIĘ", // Narastająco od 1 do n pośród wszystkich prezentacji w ramach jednej kategorii
}

export enum UserRole {
  // Role systemowe
  ADMIN = "ADMIN", // Administrator systemu

  // Role organizacyjne
  ORGANIZER = "ORGANIZER", // Organizator turnieju
  MANAGER = "MANAGER", // Manager biura zawodów (funkcje wspierające organizację)
  LEADER = "LEADER", // Prowadzący turniej (konferansjer/MC)

  // Role sędziowskie
  MAINJUDGE = "MAINJUDGE", // Sędzia główny
  JUDGE = "JUDGE", // Sędzia oceniający
  SCRUTINEER = "SCRUTINEER", // Sędzia skrutiner

  // Role pomocnicze
  INSPECTOR = "INSPECTOR", // Inspicjent
  REGISTRANT = "REGISTRANT", // Osoba zgłaszająca

  // Role prezentacyjne
  DISPLAY = "DISPLAY", // Ekran/wyświetlacz do prezentowania wyników

  // Role ogólne
  STAKEHOLDER = "STAKEHOLDER", // Pozostali interesariusze: trenerzy, tancerze, rodzice/kibice
}
